// formColumn.jsx
const columns = [
  {
    title: "Nama Lengkap",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Username Login",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Is Active",
    dataIndex: "is_active",
    key: "is_active",
    // rendering handled in MasterEmployee (Switch / Yes-No)
  },
];

const dataForm = [
  [
    {
      label: "Nama Lengkap",
      key: "name",
      placeholder: "Nama Lengkap",
      type: "text",
    },
    {
      label: "Username Login",
      key: "username",
      placeholder: "Username Login",
      type: "text",
    },
  ],
  [
    {
      label: "Password",
      key: "password",
      placeholder: "Password",
      type: "password",
    },
    {
      key: "cabang",
      label: "Cabang",
      type: "select",
      placeholder: "Pilih Cabang",
      options: [],
    },
  ],
  [
    // {
    //   label: "Role",
    //   key: "role",
    //   placeholder: "Role",
    //   type: "text",
    // },
    {
      key: "role",
      label: "Role",
      type: "select",
      placeholder: "Pilih Role",
      options: [
        { value: "approver1", label: "Approver 1" },
        { value: "approver2", label: "Approver 2" },
        { value: "approver3", label: "Approver 3" },
        { value: "cmo", label: "CMO" },
        { value: "credit_analyst", label: "Credit Analyst" },
        { value: "admin", label: "Admin" },
        { value: "admin_operation", label: "Admin Operation" },
        { value: "IT", label: "IT" },
        { value: "viewer", label: "Viewer" },
      ],
    },
    {
      label: "Is Active",
      key: "is_active",
      placeholder: "Is Active",
      type: "checkbox",
    },
  ],
];

export { columns, dataForm };
